$(window).on('scroll', function () {
  if (clientWidth > 960) {
    if (scrollTop > windowScrollHeight()) {
      $('.header--left-logo .header__inline-menu:last-of-type').slideUp(150);
    } else {
      $('.header--left-logo .header__inline-menu:last-of-type').slideDown(150);
    }
  }
})